import { Injectable } from '@angular/core';
import { PlayExecutionTableRecord } from '@r1-compass-library/components/reporting/report-table/play-execution-table-record.model';
import { PlayExecutionReportingData } from '@r1-compass-library/models';

/**
 * Service for creating the table rows for the table containing the high-level execution data (not the etable containing the interaction data in the expanded row)
 */
@Injectable({
    providedIn: 'root',
})
export class PlayExecutionTableService {
    appSpecificColumns = [
        { property: 'executionId', label: 'Execution Id' },
        { property: 'elapsedSeconds', label: 'Elapsed seconds' },
        { property: 'erroredRecords', label: 'Errored Records' },
        { property: 'createdAndUpdatedRecords', label: 'Created/Updated Records' },
    ];
    appSpecificDetails = [{ property: 'executionType', label: 'Execution Type' }];

    public getExecutionTableData(reportingData: PlayExecutionReportingData[]): PlayExecutionTableRecord[] {
        // Create a map to hold the success/failed record counts for each play result
        const playResultCounts = new Map<number, { erroredRecords: number; createdAndUpdatedRecords: number }>();
        reportingData.forEach(dat => {
            const entry = {
                erroredRecords: (dat.numRecordsFailed ?? 0) + (dat.numRecordsRejected ?? 0),
                createdAndUpdatedRecords: (dat.numRecordsCreated ?? 0) + (dat.numRecordsUpdated ?? 0),
            };
            playResultCounts.set(dat.id, entry);
        });

        // Build the report data array
        return reportingData.map(dat => {
            const totals = playResultCounts.get(dat.id) ?? { erroredRecords: 0, createdAndUpdatedRecords: 0 };
            return {
                startDate: dat.startDate,
                endDate: dat.endDate,
                status: dat.status,
                executionId: dat.executionId,
                elapsedSeconds: dat.elapsedSeconds,
                erroredRecords: totals.erroredRecords,
                createdAndUpdatedRecords: totals.createdAndUpdatedRecords,
                playResultId: dat.id,
                executionType: dat.executionType,
            };
        });
    }
}
